import { getEmbedToken } from './embedToken';

export const wrappedFetch = (url, data = {}) => {
    const embedToken = getEmbedToken();

    let headers = data.headers || {};
    if (embedToken) {
        headers['x-embed-token'] = embedToken;
    }

    // tell the server the request is coming from the checkout app
    headers['x-checkout-app-request'] = 1;

    data.headers = headers;

    return fetch(url, data);
}

export const wrappedGet = url => {
    return wrappedFetch(url, {
        method: 'GET',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        },
        credentials: 'same-origin',
    });
}
